<template>
  <div class="user-list">
    <div style="background-color: #ffffff; border-radius: 8px; margin-bottom: 20px" v-for="(user, index) in list" :key="index" @click="goData(user)">
      <div class="user-info">
        <img :src="imageView(user.avatar)" style="width: 60px; height: 88px;">
        <div style="display: flex; flex-flow: column; justify-content: space-between; height: 88px;">
          <div class="info">
            <span style="font-weight: 500">{{ user.trueName }}</span>
            <span style="margin-left: 12px">{{ getAge(user.bmBirthday) }}</span>
          </div>
          <div class="data">
            <div class="data-item">
              <div class="number">{{ user.gameCount }}</div>
              <div class="label">参赛数</div>
            </div>
            <div class="data-item">
              <div class="number">{{ user.allR }}</div>
              <div class="label">总得分</div>
            </div>
            <div class="data-item">
              <div class="number">{{ user.allH }}</div>
              <div class="label">总安打</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBMMLBBaseballStatsByUser } from "@/api/match";
import { QNImageUtil } from "@/utils";

export default {
  data() {
    return {
      accountId: '',
      list: []
    }
  },
  mounted() {
    this.accountId = this.$route.params.accountId
    this.getBMMLBBaseballStatsByUser()
  },
  methods: {
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getAge(birthday) {
      if (!birthday) return ''
      const now = new Date()
      const b = new Date(birthday)
      let age = now.getFullYear() - b.getFullYear()
      if (now.getMonth() < b.getMonth()) {
        age--
      } else if (now.getMonth() === b.getMonth() && now.getDate() < b.getDate) {
        age--
      }
      return `${age}岁`
    },
    getBMMLBBaseballStatsByUser() {
      const params = {
        accountId: this.accountId,
        needMatchInfo: 0
      }
      getBMMLBBaseballStatsByUser(params).then(res => {
        if (res) {
          const { data } = res
          this.list = data.list || []
        }
      })
    },
    goData(user) {
      this.$router.push(`/match/my-data?accountId=${this.accountId}&IDCardNo=${user.IDCardNo}`)
    }
  }
};
</script>

<style lang="scss" scoped>
.user-list {
  background-color: #F6F6F8;
  min-height: 100vh;
  padding: 20px 12px;
  .user-info {
    padding: 12px;
    display: flex;
    justify-content: space-between;
    .info {
      padding-left: 24px;
      box-sizing: border-box;
      width: 260px;
      font-size: 14px;
    }
  }
  .data {
    width: 260px;
    display: flex;
    justify-content: space-around;
    margin-bottom: 12px;
    .data-item {
      display: flex;
      flex-flow: column;
      align-items: center;
      padding-bottom: 8px;
      width: 80px;
      .number {
        font-size: 18px;
        font-weight: 500;
        padding: 4px 0;
      }
      .label {
        font-size: 12px;
        color: #8C8C8C;
      }
    }
  }
}
</style>
